import Fab from '@mui/material/Fab';
import React, { forwardRef } from 'react';

const FabButton = forwardRef((props, ref) => {
  const { children, active, onClick, endIcon, ...rest } = props;

  return (
    <Fab
      ref={ref}
      onClick={onClick}
      sx={(theme) => ({
        bgcolor: 'background.paper',
        'path, circle': {
          fill: theme.palette.text.secondary,
        },
        '&:hover, &.active': {
          bgcolor: 'background.default',
        },
        '&.Mui-disabled': {
          bgcolor: 'background.paper',
        },
        ...(active && {
          bgcolor: 'background.paper',
          'path, circle': {
            fill: theme.palette.primary.main,
          },
        }),
      })}
      {...rest}>
      {children}
    </Fab>
  );
});

export default FabButton;
